import { Message } from 'element-ui';

export const getSubPath = (url, basePath) => {
  try {
    if (typeof url !== 'string' || typeof basePath !== 'string') {
      console.error('Invalid arguments: url and basePath must be strings.');
      return null;
    }

    let pathToMatch = '';

    // 如果是完整 URL
    if (/^(http|https|file):\/\//.test(url)) {
      const urlObj = new URL(url);
      pathToMatch = urlObj.hash || '';
    } else {
      // 相对路径
      pathToMatch = url;
    }

    // 去掉开头的 "#"，统一处理
    pathToMatch = pathToMatch.trim();
    if (pathToMatch.startsWith('#')) {
      pathToMatch = pathToMatch.slice(1);
    }

    const pattern = new RegExp(`/${basePath}(/.*)`);
    const match = pathToMatch.match(pattern);

    return match ? match[1] : null;
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
};

const getSelectLabel = (arr, id, itemname) => {
  let selecteObj = {};
  selecteObj = arr.find((item) => {
    // 这里的chargingWorkNameList就是上面遍历的数据源
    return item[itemname] === id;
    // 筛选出匹配数据，是对应数据的整个对象
  });
  return selecteObj;
};
// 判断是否为对象
const isObject = (obj) => {
  return Object.prototype.toString.call(obj) === '[object Object]';
};
// 判断是否为空对象
const isEmptyObject = (obj) => {
  return JSON.stringify(obj) == '{}';
};

// 下载文件类型
const exportType = {
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  xls: 'application/vnd.ms-excel',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf: 'application/pdf',
  txt: 'text/plain',
  zip: 'application/zip',
  ppt: 'application/vnd.ms-powerpoint',
  pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  bmp: 'image/bmp',
  rar: 'application/x-rar',
  mpeg: 'video/mpeg',
  asf: 'video/x-ms-asf',
  wmv: 'video/x-ms-wmv',
  mov: 'video/quicktime',
  '3gp': 'video/3gpp',
};

/**
 * 下载文件excel的封装
 * @param {string} file_name 需要传入的文件名
 * @param {blob} content 后台返回的blob流
 * @param {string} fileType 设计的 返回 文件类型
 */
const downFile = (content, file_name = '下载文件', fileType) => {
  const showFileType = fileType || '.xlsx';

  const csvData = new Blob([content], {
    type: exportType[showFileType.replace('.', '').toLowerCase()], // 文件类型
  });
  if (window.navigator.msSaveOrOpenBlob) {
    // for IE
    window.navigator.msSaveOrOpenBlob(csvData, `${file_name}${showFileType}`);
  } else {
    // for Non-IE (chrome, firefox etc.)
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.style = 'display: none';
    const url = window.URL.createObjectURL(csvData);
    a.href = url;
    a.download = `${file_name}${showFileType}`;
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
  }
};
// 深拷贝只处理 {} 和 []
const cloneDeep = (target) => {
  if (typeof target !== 'object' || target == null) {
    // target 是 null 或者不是对象和数组, 直接返回
    return target;
  }
  // 初始化返回结果
  let result;
  // 这里判断的是传入的target 的类型, 根据target的类型来决定 result 的类型
  if (target instanceof Array) {
    result = [];
  } else {
    result = {};
  }
  for (const key in target) {
    result[key] = cloneDeep(target[key]);
  }
  // 返回结果
  return result;
};
// 获取对象类型 Object Array Date ....
const getDataType = (data) => {
  return Object.prototype.toString.call(data).slice(8, -1);
};
// 查找数组中的位置
const getArgumentIndexInAttr = (arr, arrItemName, customName) => {
  let flag = -1;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][arrItemName] == customName) {
      flag = i;
      break;
    }
  }
  return flag;
};
// 删除字符串中的空格
const deleteSpace = (str) => {
  return str.replace(/\s+/g, '');
};

function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time;
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time);
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time *= 1000;
    }
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return time_str;
}
// 判断查询数据中是否已选过
export function checkDuplicateAttr(arr, name) {
  let flag = -1;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] == name) {
      flag = i;
      break;
    }
  }
  return flag;
}
// 判断对象内属性值是否有空
const isEmptyValInObject = (obj) => {
  let flag = false;
  for (const key in obj) {
    if (obj[key] == '' || obj[key] == undefined) {
      flag = true;
      break;
    }
  }
  return flag;
};

// 图片上传前校验
const checkImgupload = (params) => {
  const isJPG = params.typeArr.indexOf(params.file.type) > -1;
  const { isMaxsize } = params;
  if (!isJPG) {
    Message.error(params.imgMessage);
    return false;
  }
  if (!isMaxsize) {
    Message.error(params.sizeMessage);
    return false;
  }
  if (isJPG && params.file.type != 'application/pdf') {
    let imgWidth = '';
    let imgHight = '';
    console.log(imgWidth, imgHight);
    const isSize = new Promise(function (resolve, reject) {
      const width = params.maxWidth;
      const height = params.maxHeight;
      const _URL = window.URL || window.webkitURL;
      const img = new Image();
      img.onload = function () {
        imgWidth = img.width;
        imgHight = img.height;
        const valid = img.width <= width && img.height <= height;
        valid ? resolve() : reject();
      };
      img.src = _URL.createObjectURL(params.file);
    }).then(
      () => {
        return params.file;
      },
      () => {
        Message.warning({
          message: `上传文件的图片大小不符合标准,图片宽度应小于${params.maxWidth}px，图片高度应小于${params.maxHeight}px`,
          btn: false,
        });
        return Promise.reject();
      }
    );
    return isSize;
  }
  return isJPG && isMaxsize;
};

export function IEVersion() {
  const { userAgent } = navigator; // 取得浏览器的userAgent字符串
  const isIE =
    userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1; // 判断是否IE<11浏览器
  const isIE11 =
    userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1;
  if (isIE || isIE11) {
    return true;
  }
  return false;
}

function NumberToText(number, type = 'upper') {
  // 配置
  const confs = {
    lower: {
      num: ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'],
      unit: ['', '十', '百', '千', '万'],
      level: ['', '万', '亿'],
    },
    upper: {
      num: ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'],
      unit: ['', '拾', '佰', '仟'],
      level: ['', '万', '亿'],
    },
    decimal: {
      unit: ['分', '角'],
    },
    maxNumber: 999999999999.99,
  };

  // 过滤不合法参数
  if (Number(number) > confs.maxNumber) {
    console.error(
      `The maxNumber is ${confs.maxNumber}. ${number} is bigger than it!`
    );
    return false;
  }

  const conf = confs[type];
  const numbers = String(Number(number).toFixed(2)).split('.');
  const integer = numbers[0].split('');
  const decimal = Number(numbers[1]) === 0 ? [] : numbers[1].split('');

  // 四位分级
  const levels = integer.reverse().reduce((pre, item, idx) => {
    const level = pre[0] && pre[0].length < 4 ? pre[0] : [];
    const value =
      item === '0' ? conf.num[item] : conf.num[item] + conf.unit[idx % 4];
    level.unshift(value);

    if (level.length === 1) {
      pre.unshift(level);
    } else {
      pre[0] = level;
    }

    return pre;
  }, []);

  // 整数部分
  const _integer = levels.reduce((pre, item, idx) => {
    let _level = conf.level[levels.length - idx - 1];
    let _item = item.join('').replace(/(零)\1+/g, '$1'); // 连续多个零字的部分设置为单个零字

    // 如果这一级只有一个零字，则去掉这级
    if (_item === '零') {
      _item = '';
      _level = '';

      // 否则如果末尾为零字，则去掉这个零字
    } else if (_item[_item.length - 1] === '零') {
      _item = _item.slice(0, _item.length - 1);
    }

    return pre + _item + _level;
  }, '');

  // 小数部分
  const _decimal = decimal
    .map((item, idx) => {
      const { unit } = confs.decimal;
      const _unit = item !== '0' ? unit[unit.length - idx - 1] : '';

      return `${conf.num[item]}${_unit}`;
    })
    .join('');

  // 如果是整数，则补个整字
  return `${_integer}元${_decimal || '整'}`;
}
// 精确两位小数
export function calRoundNum(data1, data2) {
  let m = 0;
  const s1 = data1.toString();
  const s2 = data2.toString();
  try {
    m += s1.split('.')[1] ? s1.split('.')[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  try {
    m += s2.split('.')[1] ? s2.split('.')[1].length : 0;
  } catch (e) {
    console.log(e);
  }
  return (Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) / 10 ** m;
}

/**
 * 文件导出 后台返回JSON错误信息处理
 * @param 接口返回的数据
 */
export function fileExportResponseError(data) {
  const fileReader = new FileReader();
  fileReader.onload = function () {
    try {
      // 说明是普通对象数据，后台转换失败
      const jsonData = JSON.parse(fileReader.result);
      Message.error(jsonData.message);
    } catch (err) {
      // 解析对象失败，说明是正常的文件流
      console.log(err);
    }
  };
  fileReader.readAsText(data);
}

export function isExistAttrInArr(arr, attr, val) {
  let flag = false;
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][attr] == val) {
      flag = true;
      break;
    }
  }
  return flag;
}

/**
 * 获取当前页面URL参数
 * @param 传入参数key返回value
 */
export function getUrlKey(name) {
  return (
    decodeURIComponent(
      (new RegExp(`[?|&]${name}=` + `([^&;]+?)(&|#|;|$)`).exec(
        location.href
      ) || [''])[1]?.replace(/\+/g, '%20')
    ) || null
  );
}

export function dealAttachmentName(attachmentName) {
  if (attachmentName.length > 10) {
    const preName = attachmentName.substr(0, 3);
    const lastName = attachmentName.substring(
      attachmentName.lastIndexOf('.') - 2
    );
    return `${preName}...${lastName}`;
  }
  return attachmentName;
}

export function getYearAndMonth(start, end) {
  const result = [];
  const starts = start.split('-');
  const ends = end.split('-');
  let staYear = parseInt(starts[0]);
  let staMon = parseInt(starts[1]);
  const endYear = parseInt(ends[0]);
  const endMon = parseInt(ends[1]);
  while (staYear <= endYear) {
    if (staYear === endYear) {
      while (staMon < endMon) {
        staMon++;
        const str = `${staYear}-${staMon >= 10 ? staMon : `0${staMon}`}`;
        result.push(str);
      }
      staYear++;
    } else {
      staMon++;
      if (staMon > 12) {
        staMon = 1;
        staYear++;
      }
      const str = `${staYear}-${staMon >= 10 ? staMon : `0${staMon}`}`;
      result.push(str);
    }
  }
  return result;
}

// 时间格式处理
export function dateformate(data, format) {
  if (!data) {
    return '';
  }
  if (typeof data === 'string') {
    data = data.replace(/-/g, '/');
  }
  data = new Date(data);
  const o = {
    'M+': data.getMonth() + 1, // month
    'd+': data.getDate(), // day
    'h+': data.getHours(), // hour
    'm+': data.getMinutes(), // minute
    's+': data.getSeconds(), // second
    'q+': Math.floor((data.getMonth() + 3) / 3), // quarter
    S: data.getMilliseconds(), // millisecond
  };
  if (/(y+)/.test(format)) {
    format = format.replace(
      RegExp.$1,
      `${data.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
  }
  for (const k in o) {
    if (new RegExp(`(${k})`).test(format)) {
      format = format.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : `00${o[k]}`.substr(`${o[k]}`.length)
      );
    }
  }
  return format;
}

// 格式化时间
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      `${date.getFullYear()}`.substr(4 - RegExp.$1.length)
    );
  }
  const o = {
    'M+': date.getMonth() + 1,
    'd+': date.getDate(),
    'h+': date.getHours(),
    'm+': date.getMinutes(),
    's+': date.getSeconds(),
  };
  for (const k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      const str = `${o[k]}`;
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      ); // 如果传入的格式是1位，则返回原始值，否则补零。
    }
  }
  return fmt;
}

function padLeftZero(str) {
  return `00${str}`.substr(str.length);
}

export function getDayAll(starDay, endDay, timeType) {
  const arr = [];
  const dates = [];

  // 设置两个日期UTC时间
  const db = new Date(starDay);
  const de = new Date(endDay);

  // 获取两个日期GTM时间
  const s = db.getTime() - 24 * 60 * 60 * 1000;
  const d = de.getTime() - 24 * 60 * 60 * 1000;

  // 获取到两个日期之间的每一天的毫秒数
  for (let i = s; i <= d; ) {
    i += 24 * 60 * 60 * 1000;
    arr.push(parseInt(i));
  }

  // 获取每一天的时间  YY-MM-DD
  for (const j in arr) {
    const time = new Date(arr[j]);
    const year = time.getFullYear(time);
    const mouth =
      time.getMonth() + 1 >= 10
        ? time.getMonth() + 1
        : `0${time.getMonth() + 1}`;
    const day = time.getDate() >= 10 ? time.getDate() : `0${time.getDate()}`;
    let YYMMDD = '';
    if (timeType) {
      YYMMDD = year + timeType + mouth + timeType + day;
    } else {
      YYMMDD = `${year}年${mouth}月${day}日`;
    }
    dates.push(YYMMDD);
  }

  return dates;
}

/**
 * 深拷贝 可以解决循环引用问题
 * @param 返回一个promise
 */
export function deepClone(obj) {
  return new Promise((resolve) => {
    const { port1, port2 } = new MessageChannel();
    port1.postMessage(obj);
    port2.onmessage = (msg) => {
      resolve(msg.data);
    };
  });
}

// 判断是否是数字
const isNumber = (val) => {
  const regPos = /^\d+(\.\d+)?$/; // 非负浮点数
  const regNeg =
    /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  }
  return false;
};
// 保留3位小数
const isNumber2 = (val) => {
  const regPos = /^\d+(\.\d{1,3})?$/; // 非负浮点数
  if (regPos.test(val)) {
    return true;
  }
  return false;
};

// 提示时间
export function durationTime() {
  return 5000;
}

export function thousandsSeparator(value) {
  if (!value && value !== 0) return ''; // 如果传入的值为空或undefined，返回空字符串
  // 字符串类型
  if (isNumber(value) && typeof value === 'string') {
    value = Number(value);
  }
  // 使用正则表达式和replace方法将数字转换为千分位格式
  return value.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function timestampToTime(timestamp) {
  const date = new Date(timestamp); // 时间戳为10位需*1000，时间戳为13位的话不需乘1000

  const Y = `${date.getFullYear()}-`;

  const M = `${
    date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
  }-`;

  const D = `${date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()} `;

  const h = `${
    date.getHours() < 10 ? `0${date.getHours()}` : date.getHours()
  }:`;

  const m = `${
    date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes()
  }:`;
  const s =
    date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();

  return Y + M + D + h + m + s;
}

export default {
  getSelectLabel,
  isObject,
  downFile,
  cloneDeep,
  getDataType,
  getArgumentIndexInAttr,
  deleteSpace,
  isEmptyObject,
  isEmptyValInObject,
  checkDuplicateAttr,
  parseTime,
  formatDate,
  checkImgupload,
  NumberToText,
  fileExportResponseError,
  isExistAttrInArr,
  getDayAll,
  dateformate,
  deepClone,
  getUrlKey,
  getYearAndMonth,
  durationTime,
  isNumber,
  isNumber2,
  thousandsSeparator,
};
